var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3186",
    "data-name": "Rectangle 3186",
    width: 14,
    height: 14,
    transform: "translate(1088 566)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5903",
    "data-name": "Mask Group 5903",
    transform: "translate(-1088 -566)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(1088.573 546.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7458",
    "data-name": "Group 7458",
    transform: "translate(0 20.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8879",
    "data-name": "Path 8879",
    d: "M218.886,333.382a.661.661,0,1,0,0,1.321.661.661,0,0,0,0-1.321Z",
    transform: "translate(-212.458 -325.124)",
    fill: "#f55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8880",
    "data-name": "Path 8880",
    d: "M12.541,31.481a2.256,2.256,0,0,0,.005-2.283L8.408,22.031a2.28,2.28,0,0,0-3.958,0L.307,29.2a2.289,2.289,0,0,0,1.982,3.43h8.266A2.276,2.276,0,0,0,12.541,31.481Zm-.9-.518a1.249,1.249,0,0,1-1.091.632H2.286a1.232,1.232,0,0,1-1.078-.618,1.25,1.25,0,0,1,0-1.26l4.143-7.172a1.244,1.244,0,0,1,2.162,0l4.141,7.172A1.234,1.234,0,0,1,11.643,30.963Z",
    transform: "translate(0 -20.882)",
    fill: "#f55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8881",
    "data-name": "Path 8881",
    d: "M218.235,157.195a.718.718,0,0,0-.51.721c.016.209.029.42.045.629.045.8.09,1.575.135,2.37a.484.484,0,0,0,.494.465.494.494,0,0,0,.494-.481c0-.164,0-.314.016-.481.029-.51.061-1.02.09-1.53.016-.33.045-.661.061-.991a.816.816,0,0,0-.061-.33A.662.662,0,0,0,218.235,157.195Z",
    transform: "translate(-211.972 -153.575)",
    fill: "#f55353"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponErrorIcon);
export default __webpack_public_path__ + "static/media/couponErrorIcon.7f2526cc22624658acdf891f2f57e59d.svg";
export { ForwardRef as ReactComponent };